import React from "react";
import {
  LegalPage,
  LegalSection,
  LegalMail,
  LegalRoute,
} from "../components/Legal";

export default function Terms({ language = "de" }) {
  const de = language === "de";

  return (
    <LegalPage
      title={de ? "Nutzungsbedingungen" : "Términos de uso"}
      subtitle={
        de
          ? "Bedingungen für die Nutzung von www.bw-verlag.at."
          : "Condiciones de uso de www.bw-verlag.at."
      }
      updated={de ? "Stand: September 2026" : "Actualizada en septiembre de 2026"}
    >
      <LegalSection title={de ? "1. Geltungsbereich" : "1. Ámbito de aplicación"}>
        <p>
          {de
            ? "Diese Bedingungen gelten für die Nutzung dieser Website. Betreiber ist der Blauer Wolf Verlag, César J. Cárdenas Lara, Ober-Pabneukirchen 17, 4363 Pabneukirchen, Österreich. Die vollständigen Angaben stehen im "
            : "Estas condiciones se aplican al uso de este sitio web. El titular es Blauer Wolf Verlag, César J. Cárdenas Lara, Ober-Pabneukirchen 17, 4363 Pabneukirchen, Austria. Los datos completos figuran en el "}
          <LegalRoute to={`/${language}/impressum`}>
            {de ? "Impressum" : "aviso legal"}
          </LegalRoute>
          .
        </p>
      </LegalSection>

      <LegalSection title={de ? "2. Kein Onlineshop" : "2. Este sitio no es una tienda"}>
        <p>
          {de
            ? "Über diese Website werden keine Bücher verkauft und keine Zahlungen abgewickelt. Die Angaben zu unseren Titeln sind Information, kein Angebot im Rechtssinn. Bücher erhalten Sie über den Buchhandel und die genannten Händler; dort gelten deren Bedingungen und deren Preise."
            : "A través de este sitio no se venden libros ni se tramitan pagos. La información sobre nuestros títulos es informativa y no constituye una oferta en sentido jurídico. Los libros se adquieren en librerías y en las tiendas indicadas, donde rigen sus propias condiciones y precios."}
        </p>
        <p>
          {de
            ? "Leistungen der Werkstatt (Lektorat, Satz, Gestaltung, Übersetzung) kommen nicht durch das Absenden des Formulars zustande, sondern erst durch eine ausdrückliche schriftliche Vereinbarung über Umfang, Frist und Honorar."
            : "Los servicios del taller (corrección, maquetación, diseño, traducción) no se contratan al enviar el formulario, sino mediante un acuerdo escrito y expreso sobre alcance, plazo y honorarios."}
        </p>
      </LegalSection>

      <LegalSection title={de ? "3. Urheberrecht" : "3. Derechos de autor"}>
        <p>
          {de
            ? "Texte, Buchumschläge, Illustrationen, Wortmarke und Signet dieser Website sind urheber- bzw. kennzeichenrechtlich geschützt. Für den privaten Gebrauch dürfen Sie Seiten ansehen, ausdrucken und verlinken. Jede weitere Verwertung — insbesondere Vervielfältigung, Bearbeitung, öffentliche Zugänglichmachung oder die Nutzung zu kommerziellen Zwecken — bedarf unserer vorherigen schriftlichen Zustimmung."
            : "Los textos, cubiertas, ilustraciones, el nombre y el sello de este sitio están protegidos por los derechos de autor y de marca. Para uso privado puede consultar, imprimir y enlazar las páginas. Cualquier otra explotación —en particular la reproducción, transformación, puesta a disposición del público o el uso comercial— requiere nuestra autorización previa por escrito."}
        </p>
        <p>
          {de
            ? "Presse- und Ansichtsexemplare sowie Bildmaterial in Druckauflösung stellen wir auf Anfrage gern zur Verfügung: "
            : "Facilitamos con gusto ejemplares de prensa y de muestra, así como imágenes en resolución de imprenta, a quien lo solicite: "}
          <LegalMail />.
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "4. Eingesandte Texte" : "4. Textos que usted nos envía"}
      >
        <p>
          {de
            ? "Wenn Sie uns ein Manuskript schicken, bleiben alle Rechte daran bei Ihnen. Wir erwerben durch die Einsendung keine Rechte und übernehmen keine Verpflichtung zur Veröffentlichung, zur Begutachtung oder zur Rücksendung. Bitte senden Sie keine Originale oder Unikate. Für den Verlust unverlangt eingesandter Unterlagen haften wir nur bei Vorsatz oder grober Fahrlässigkeit."
            : "Si nos envía un manuscrito, todos los derechos siguen siendo suyos. El envío no nos transfiere ningún derecho ni nos obliga a publicar, valorar ni devolver el texto. Le pedimos que no envíe originales ni ejemplares únicos. De la pérdida de material no solicitado respondemos únicamente en caso de dolo o culpa grave."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "5. Inhalte und Haftung" : "5. Contenidos y responsabilidad"}
      >
        <p>
          {de
            ? "Wir erstellen die Inhalte dieser Website mit Sorgfalt, können aber für Aktualität, Richtigkeit und Vollständigkeit keine Gewähr übernehmen. Angaben zu Preisen, Umfang und Erscheinungsterminen können sich ändern. Für Schäden aus der Nutzung oder Nichtnutzung der Website haften wir nur bei Vorsatz oder grober Fahrlässigkeit; Ansprüche nach dem Produkthaftungsgesetz und bei Personenschäden bleiben unberührt."
            : "Elaboramos los contenidos de este sitio con cuidado, pero no podemos garantizar su actualidad, exactitud ni integridad. Los datos sobre precios, extensión y fechas de publicación pueden cambiar. Por los daños derivados del uso o de la imposibilidad de uso del sitio respondemos solo en caso de dolo o culpa grave; quedan a salvo las reclamaciones por daños personales y las derivadas de la ley de responsabilidad por producto."}
        </p>
      </LegalSection>

      <LegalSection title={de ? "6. Verfügbarkeit" : "6. Disponibilidad"}>
        <p>
          {de
            ? "Wir bemühen uns um einen durchgehenden Betrieb, schulden aber keine bestimmte Verfügbarkeit. Wartungsarbeiten, technische Störungen und Ausfälle beim Hostinganbieter können zu Unterbrechungen führen."
            : "Procuramos que el sitio esté siempre operativo, pero no garantizamos una disponibilidad determinada. Las tareas de mantenimiento, las averías técnicas y las incidencias del proveedor de alojamiento pueden causar interrupciones."}
        </p>
      </LegalSection>

      <LegalSection title={de ? "7. Externe Links" : "7. Enlaces externos"}>
        <p>
          {de
            ? "Diese Website verweist an einzelnen Stellen auf fremde Seiten, etwa auf Händler. Auf deren Inhalte haben wir keinen Einfluss; verantwortlich ist stets der jeweilige Anbieter. Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße erkennbar. Werden uns solche bekannt, entfernen wir den Link."
            : "Este sitio remite en algunos puntos a páginas ajenas, por ejemplo a tiendas. No tenemos influencia sobre sus contenidos; el responsable es siempre su respectivo titular. En el momento de crear el enlace no se apreciaban infracciones. Si llegan a nuestro conocimiento, retiramos el enlace."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "8. Datenschutz" : "8. Protección de datos"}
      >
        <p>
          {de
            ? "Wie wir mit personenbezogenen Daten umgehen, steht in der "
            : "El tratamiento de los datos personales se explica en la "}
          <LegalRoute to={`/${language}/privacy`}>
            {de ? "Datenschutzerklärung" : "política de privacidad"}
          </LegalRoute>
          .
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "9. Anwendbares Recht" : "9. Derecho aplicable"}
      >
        <p>
          {de
            ? "Es gilt österreichisches Recht. Zwingende Verbraucherschutzvorschriften des Staates, in dem ein Nutzer seinen gewöhnlichen Aufenthalt hat, bleiben davon unberührt."
            : "Se aplica el derecho austriaco. Ello no afecta a las disposiciones imperativas de protección de los consumidores del Estado en que el usuario tenga su residencia habitual."}
        </p>
      </LegalSection>

      <LegalSection title={de ? "10. Änderungen" : "10. Modificaciones"}>
        <p>
          {de
            ? "Wir können diese Bedingungen anpassen, wenn sich die Website oder die Rechtslage ändert. Es gilt die jeweils hier veröffentlichte Fassung; das Datum oben zeigt den Stand."
            : "Podemos adaptar estas condiciones si cambia el sitio o la normativa aplicable. Rige siempre la versión publicada en esta página; la fecha superior indica su estado."}
        </p>
      </LegalSection>
    </LegalPage>
  );
}
